import React, { ReactElement } from 'react';
import { Image, ImageProps } from '../Image';
import logo from './logo.jpg';

export type LogoProps = Omit<ImageProps, 'image'>;

export const Logo = (props: LogoProps): ReactElement => (
  <Image image={logo} {...props} />
);
